import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import appStoreBadge from '../Assets/Images/apple.png'
import playBadge from '../Assets/Images/google.png'
import qrCode from '../Assets/Logo/qr-app.svg'
import config from '../Config'
import { t } from '../i18n'
import { useUi } from '../State/Ui'
import { applyAdConsent, readConsent, saveConsent } from '../Utils/consent'
import { CloseIcon } from './Icons'
import { LogoIcon } from './Logo'

/* Desktop "Preuzmi aplikaciju" (spec 5.10). The QR code is the smart link
   https://instapres.com/app?utm_source=web&utm_medium=qr (spec 8). */
export function QrModal() {
  const { qrOpen, closeQr } = useUi()
  const closeButton = useRef(null)

  useEffect(() => {
    if (!qrOpen) return undefined
    const previous = document.activeElement
    closeButton.current?.focus()
    const onKey = (e) => e.key === 'Escape' && closeQr()
    document.addEventListener('keydown', onKey)
    document.body.classList.add('no-scroll')
    return () => {
      document.removeEventListener('keydown', onKey)
      document.body.classList.remove('no-scroll')
      previous?.focus?.()
    }
  }, [qrOpen, closeQr])

  if (!qrOpen) return null
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div className="modal-backdrop" onClick={closeQr}>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
      <div
        className="modal qr-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="qr-title"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          ref={closeButton}
          type="button"
          className="icon-button modal-close"
          aria-label={t('common.close')}
          onClick={closeQr}
        >
          <CloseIcon size={20} />
        </button>
        <LogoIcon size={44} />
        <h2 id="qr-title">{t('qr.title')}</h2>
        <p>{t('qr.text')}</p>
        <img className="qr-code" src={qrCode} width="184" height="184" alt="" />
        <p className="qr-or">{t('qr.or')}</p>
        <div className="store-badges">
          <a href={config.APP_STORE_LINK} target="_blank" rel="noopener noreferrer">
            <img src={appStoreBadge} alt={t('qr.appStore')} height="44" />
          </a>
          <a href={config.PLAY_STORE_LINK} target="_blank" rel="noopener noreferrer">
            <img src={playBadge} alt={t('qr.googlePlay')} height="44" />
          </a>
        </div>
      </div>
    </div>
  )
}

export function Toast() {
  const { toast, dismissToast } = useUi()
  return (
    <div className="toast-region" role="status" aria-live="polite">
      {toast && (
        <div className="toast" key={toast.id}>
          <span>{toast.message}</span>
          {toast.action && (
            <button
              type="button"
              className="toast-action"
              onClick={() => {
                toast.action.onClick()
                dismissToast()
              }}
            >
              {toast.action.label}
            </button>
          )}
        </div>
      )}
    </div>
  )
}

/* Personalised ads only with consent (spec 5.12); until then, and with
   "Samo neophodni", only non-personalised ones. */
export function ConsentBanner() {
  const [choice, setChoice] = useState(readConsent)
  if (choice) return null
  const choose = (value) => {
    saveConsent(value)
    applyAdConsent(value)
    setChoice(value)
  }
  return (
    <div className="consent" role="region" aria-label={t('consent.more')}>
      <p>
        {t('consent.text')} <Link to="/privacy-policy.html">{t('consent.more')}</Link>
      </p>
      <div className="consent-actions">
        <button
          type="button"
          className="btn btn-secondary btn-small"
          onClick={() => choose('necessary')}
        >
          {t('consent.necessary')}
        </button>
        <button type="button" className="btn btn-primary btn-small" onClick={() => choose('all')}>
          {t('consent.accept')}
        </button>
      </div>
    </div>
  )
}
